import { useState } from 'react';
export function useLoadingContext() {
    var _a = useState(false), imxLoading = _a[0], setImxLoading = _a[1];
    var _b = useState(false), serverLoading = _b[0], setServerLoading = _b[1];
    return { imxLoading: imxLoading, setImxLoading: setImxLoading, serverLoading: serverLoading, setServerLoading: setServerLoading };
}
